import { z } from "zod";

export const visaCountrySelectSchema = z
  .object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(2, "Country name must be at least 2 characters"),
    iso: z.string().optional(),
    iso3: z.string().optional(),
    phone_code: z.union([z.string(), z.number()]).optional(),
  })
  .nullable();

export const visaTypeSelectSchema = z
  .object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "Visa type is required"),
  })
  .nullable();

export const visaSearchSchema = z.object({
  country: visaCountrySelectSchema,
  visa_type: visaTypeSelectSchema,
  travelers: z
    .number()
    .int("Travelers must be a whole number")
    .min(1, "Please select number of travelers")
    .max(20, "Travelers cannot be more than 20"),
});
